<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("purchase") }} {{ $t("order") }}</div>
        <div class="section-subTitle my-2">
          {{ $tc("listofall") }} {{ $t("purchase") }} {{ $t("order") }}
          {{ $tc("incinematic") }}
        </div>
      </div>
      <div>
        <router-link
          variant="default"
          class="btn-blue"
          to="/fnb/add-purchase-order"
          >{{ $tc("add") }}</router-link
        >
      </div>
    </div>

    <div class="white-wrapper pt-0 mt-2">
      <div class="d-flex justify-content-between align-items-center py-3">
        <div class="mr-2">
          <b-form-input
            v-debounce:300="getPurchaseOrderList"
            v-model="searchValue"
            type="search"
            placeholder="Search..."
          ></b-form-input>
        </div>

        <div class="d-flex align-items-center justify-content-between w-100">
          <FilterByStatusDropdown2
            :onSelect="
              (searchFilter) => {
                getPurchaseOrderList(e, searchFilter);
              }
            "
            class="mx-2"
          />
          <div class="row">
            <div class="col-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <button
                    class="btn-clearDate"
                    v-if="fromDate"
                    v-on:click="fromDate = ''"
                  >
                    ✖
                  </button>
                  <Datepicker
                    :monday-first="true"
                    v-model="fromDate"
                    ref="programaticOpen"
                    :value="fromDate"
                    v-validate="'required'"
                    typeable
                  ></Datepicker>
                  <label :class="fromDate ? 'active' : ''">{{
                    $t("fromdate")
                  }}</label>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <button
                    class="btn-clearDate"
                    v-if="toDate"
                    v-on:click="toDate = ''"
                  >
                    ✖
                  </button>
                  <Datepicker
                    :monday-first="true"
                    v-model="toDate"
                    ref="programaticOpen"
                    :value="toDate"
                    v-validate="'required'"
                    typeable
                    :disabledDates="{ to: fromDate }"
                  ></Datepicker>
                  <label :class="toDate ? 'active' : ''">{{
                    $t("todate")
                  }}</label>
                </div>
              </div>
            </div>
            <div class="col-2">
              <button @click="getPurchaseOrderList" class="btn-blue">
                Fetch
              </button>
            </div>

            <div class="col-3">
              <b-dropdown id="listview" variant="outline-blue">
                <template v-slot:button-content>
                  Viewing&nbsp;
                  <strong>{{ selectedvalue }}</strong>
                  &nbsp;Of&nbsp;
                  <strong>{{ rows }}</strong>
                </template>
                <b-dropdown-item
                  v-for="(list, listIndex) in viewingnumbers"
                  :key="listIndex"
                  @click="onDropDownChangeValue(list.name)"
                  href="#"
                  >{{ list.name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div
            v-if="purchaseOrders && purchaseOrders.length > 0"
            class="d-flex justify-content-end align-items-center"
          >
            <div style="white-space:nowrap">{{ $t("download") }} as:</div>
            <!-- <a
          v-if="getDailyPDFFileName"
          :href="BASE_URL+getDailyPDFFileName"
          target="_blank"
          download
          title="Download as PDF"
        >
          <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
        </a>-->
            <a
              v-if="excelFile"
              :href="BASE_URL + excelFile"
              target="_blank"
              title="Download as Excel"
              download
            >
              <img
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
                class="mx-1"
              />
            </a>
          </div>
          <!-- <div class="viewing-status">
          {{ $t('viewing') }}
          <span>1-20</span>
          {{ $t('of') }}
          <span>36</span>
          <button class="btn-prev mx-2"></button>
          <button class="btn-next"></button>
          </div>-->
          <button
            class="btnj btn-gridView mr-3"
            v-if="GridViewFlag"
            :class="gridView ? 'active' : ''"
            v-on:click="viewType('gridView')"
          ></button>
          <button
            class="btnj btn-listView"
            v-if="GridViewFlag"
            :class="listView ? 'active' : ''"
            v-on:click="viewType('listView')"
          ></button>
        </div>
      </div>

      <!-- LIST VIEW -->
      <table class="list-view-table text-center" v-if="listView">
        <thead>
          <tr>
            <th class="text-left">
              <img
                v-if="orderAscending"
                @click="
                  onSortValue('orderno', (orderAscending = !orderAscending))
                "
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="
                  onSortValue('orderno', (orderAscending = !orderAscending))
                "
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("ponumber") }}
            </th>
            <th class="text-left">
              <img
                v-if="dateAscending"
                @click="onSortValue('date', (dateAscending = !dateAscending))"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('date', (dateAscending = !dateAscending))"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("date") }}
            </th>
            <th class="text-left">{{ $tc("cinema", 1) }}</th>
            <th class="text-left">{{ $tc("vendor", 1) }}</th>
            <th class="text-right"
              >{{ $t("total") }} {{ $t("order_value") }}</th
            >
            <th class="text-right">{{ $t("Receipt Status") }}</th>
            <th class="text-right">
              <span class="pr-5">{{ $tc("status", 1) }}</span>
            </th>
          </tr>
        </thead>

        <tbody v-if="purchaseOrders.length > 0">
          <tr
            v-for="(purchaseOrder, purchaseOrderList) in purchaseOrders"
            :key="purchaseOrderList"
          >
            <td
              class="text-left"
              :class="[
                purchaseOrder.transfer_stock_id !== null ? 'text-blue' : '',
              ]"
              >{{ purchaseOrder.po_number }}</td
            >
            <td class="text-left">{{ purchaseOrder.po_date | dateparse }}</td>
            <td class="text-left">{{ purchaseOrder.cine_name }}</td>
            <td
              class="text-left"
              :class="[
                purchaseOrder.transfer_stock_id !== null ? 'text-blue' : '',
              ]"
              >{{ purchaseOrder.v_name }}
            </td>
            <td class="text-right">{{
              currFormat(purchaseOrder.po_total_amount)
            }}</td>
            <td class="text-right">
              <span v-if="purchaseOrder.transfer_stock_id !== null">
                {{ purchaseOrder.transfer_status }}
              </span>
              <span v-else>
                {{
                  purchaseOrder.po_is_approved == "Y" &&
                  purchaseOrder.po_is_active === "Y"
                    ? "Approve"
                    : purchaseOrder.po_is_approved == "N" &&
                      purchaseOrder.po_is_active === "Y"
                    ? "Pending"
                    : purchaseOrder.po_is_approved == "N" &&
                      purchaseOrder.po_is_active === "N"
                    ? "Pending"
                    : "Inactive"
                }}
              </span>
            </td>
            <td>
              <div class="d-flex justify-content-end align-items-center">
                <!-- <label class="ios-switch">
                  <input
                    type="checkbox"
                    class="ios-checkbox"
                    :checked="purchaseOrder.po_is_active == 'Y' ? true : false"
                    disabled
                  />
                  <span class="switch-slider"></span>
                </label> -->
                <StatusDot
                  :status="
                    purchaseOrder.po_is_approved == 'Y' &&
                    purchaseOrder.po_is_active === 'Y'
                      ? 'draft'
                      : purchaseOrder.po_is_approved == 'N'
                      ? 'unapproved'
                      : purchaseOrder.po_is_active === 'Y'
                      ? 'active'
                      : 'inactive'
                  "
                />
                <div>
                  <b-dropdown right variant="edit" class="ml-4">
                    <b-dropdown-item
                      v-if="
                        purchaseOrder.po_lock !== 'Y' &&
                          purchaseOrder.transfer_stock_id === null
                      "
                      @click="
                        goToRoute('/fnb/edit-purchase-order', purchaseOrder)
                      "
                    >
                      <span class="edit-pen"></span>
                      {{ $t("edit") }}
                    </b-dropdown-item>

                    <b-dropdown-item
                      @click="
                        goToRoute('/fnb/view-purchase-order', purchaseOrder)
                      "
                    >
                      <span class="icon-eye mr-1"></span>
                      {{ $t("view") }}
                    </b-dropdown-item>
                    <!-- Approve Purchase Order -->
                    <b-dropdown-item
                      v-if="purchaseOrder.po_is_approved == 'N'"
                      @click="
                        approvePurchaseOder(purchaseOrderList, purchaseOrder)
                      "
                    >
                      <span class="edit-pen"></span>
                      {{ $t("Approve") }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="6">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(purchaseOrder, purchaseOrderkey) in purchaseOrders"
        :key="purchaseOrderkey"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ purchaseOrder.po_number }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="purchaseOrder.po_lock !== 'Y'"
                  @click="goToRoute('/fnb/edit-purchase-order', purchaseOrder)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/fnb/view-purchase-order', purchaseOrder)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <!-- <label class="ios-switch">
                <input type="checkbox" class="ios-checkbox" />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import PosFnbService from "@/services/PosFnbService";
  import StatusDot from "@/components/Partials/StatusDot.vue";
  import FilterByStatusDropdown2 from "@/components/Partials/FilterByStatusDropdown2.vue";
  import NoRecords from "@/components/Partials/NoRecords.vue";

  export default {
    components: {
      StatusDot,
      FilterByStatusDropdown2,
      NoRecords,
    },
    data() {
      return {
        perPage: 10,
        currentPage: 1,
        rows: 0,
        selectedvalue: "10",
        orderAscending: true,
        cinema_id: null,
        dateAscending: true,
        gridView: false,
        listView: true,
        purchaseOrders: [],
        searchValue: "",
        excelFile: null,
        fromDate: "",
        toDate: "",
      };
    },
    watch: {
      searchValue: function(newValue, oldValue) {
        if (String(newValue).length == 0) {
          this.searchValue = "";
          this.getPurchaseOrderList();
        }
      },
    },
    mounted() {
      let obj = this.secureStore.get("USINFO").cinema_id;
      this.cinema_id = obj;
      this.getPurchaseOrderList();
    },
    beforeMount() {
      this.getviewingnumber();
    },
    methods: {
      getviewingnumber() {
        this.viewingnumbers = [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ];
      },
      onDropDownChangeValue(event) {
        if (event == "All") {
          this.perPage = this.rows;
          this.selectedvalue = event;
          this.onChangePagination();
        } else {
          console.log("Numbers :", event);
          this.selectedvalue = event;
          this.perPage = event;
          console.log("perPage :", this.perPage);
          this.onChangePagination();
        }
      },
      /* eslint-disable */
      onChangePagination: function(event) {
        // console.log(event);
        if (event === undefined) {
          this.currentPage = 1;
          this.getPurchaseOrderList();
        } else {
          this.currentPage = event;
          this.getPurchaseOrderList();
        }
      },
      onSortValue: function(column, ascending) {
        if (column == "orderno") {
          if (ascending == false) {
            this.purchaseOrders = this.purchaseOrders.sort(function(a, b) {
              return b.po_number - a.po_number;
            });
          } else {
            this.purchaseOrders = this.purchaseOrders.sort(function(a, b) {
              return a.po_number - b.po_number;
            });
          }
          // this.getOrderOrderNo = "desc";
        } else if (column == "date") {
          if (ascending == false) {
            this.purchaseOrders = this.purchaseOrders.sort(function(a, b) {
              return new Date(a.po_date) - new Date(b.po_date);
            });
          } else {
            this.purchaseOrders = this.purchaseOrders.sort(function(a, b) {
              return new Date(b.po_date) - new Date(a.po_date);
            });
          }
          // this.getOrderDate = "desc";
        }
      },
      viewType: function(viewType) {
        if (viewType == "gridView") {
          this.gridView = true;
          this.listView = false;
        } else if ((viewType = "listView")) {
          this.listView = true;
          this.gridView = false;
        }
      },
      goToRoute: function(path, { po_number, po_id }) {
        this.$router.push({
          path: path,
          query: {
            po_number: po_number,
            po_id: po_id,
          },
        });
      },
      approvePurchaseOder: function(purchaseOrderIndex, purchaseOrder) {
        console.log("approvePurchaseOder", {
          purchaseOrderIndex,
          purchaseOrder,
        });
        let { po_id } = purchaseOrder;
        let payload = { po_id };

        PosFnbService.ApprovePurchaseOrder(payload)
          .then((response) => {
            const { data } = response;

            if (data && data.status) {
              this.getPurchaseOrderList();
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      getPurchaseOrderList: function(e, searchFilter = "ALL") {
        let payload = {
          limit: this.perPage,
          currentPage: this.currentPage,
          searchValue: this.searchValue,
          fromDate: this.fromDate,
          toDate: this.toDate,
          cinema_id: this.cinema_id,
          searchFilter: searchFilter,
        };
        PosFnbService.GetAllPurchaseOrders(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.purchaseOrders = data.Records;
              this.excelFile = data.FinalExcelFile;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
                this.selectedvalue =
                  this.selectedvalue < 10 ? 10 : this.selectedvalue;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.purchaseOrders = [];
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
    },
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/PurchaseOrderComponents/purchaseOrder.vue